export const TYPING_SPEED_MS = 45;
export const DELETING_SPEED_MS = 22;
export const PAUSE_AFTER_TYPED_MS = 2200;
export const PAUSE_BEFORE_NEXT_MS = 400;
